import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  LicenseItem,
  LicenseQuery
} from '@eggplant/types'

interface Props {
  params?: LicenseQuery
  onSuccess: (value: LicenseItem) => void
  children?: () => void
}

const CreateAiLicenseRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/licenses`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateAiLicenseRequest
